<h2 mat-dialog-title>{{ "brand.moveCampaign.dialogTitle" | translate }}</h2>
<mat-dialog-content>
  <div *ngIf="!loading" class="brand-selection">
    <div *ngFor="let brand of brands" class="move-to-brand-select">
      <div
        class="move-to-brand-select__option"
        (click)="selectBrand(brand)"
        [ngClass]="{
          active: isBrandSelected(brand),
          clickable: !isBrandSelected(brand)
        }"
      >
        <span class="move-to-brand-select__option__text">{{
          brand.companyName
        }}</span>
        <mat-icon
          *ngIf="isBrandSelected(brand)"
          class="move-to-brand-select__option__check"
          >check</mat-icon
        >
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="brands-loader">
    <mat-spinner [diameter]="20"></mat-spinner>
  </div>
  <div *ngIf="!loading && brands.length === 0" class="no-brands">
    {{ "brand.moveCampaign.noBrandsFound" | translate }}
  </div>
  <mat-paginator
    #paginator
    *ngIf="!loading && totalBrands > limit"
    class="paginator--centered"
    [length]="totalBrands"
    [pageSize]="limit"
    [pageIndex]="pageIndex"
    [hidePageSize]="true"
    (page)="onPageChange($event)"
  ></mat-paginator>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="button-link" tabindex="-1" [mat-dialog-close]="">
    {{ "shared.cancel" | translate }}
  </button>
  <button
    class="button-orange"
    (click)="move()"
    [disabled]="isMoveButtonDisabled()"
  >
    <span *ngIf="moving">{{
      "brand.moveCampaign.movingButton" | translate
    }}</span>
    <span *ngIf="!moving">{{
      "brand.moveCampaign.moveButton" | translate
    }}</span>
  </button>
</mat-dialog-actions>
